import { RECOMMENDED_SOL_BALANCE } from 'solana-bc/sol-fee'
import type { FuelState } from '../utils/get-funding-state'
import styles from '../neon-wallets.module.scss'

const SEGMENTS = 5

interface Props {
  sol: number
  state: FuelState
}

/** SOL as a fuel tank: full at the recommended balance, one segment per fifth. */
export const FuelGauge: React.FC<Props> = ({ sol, state }) => {
  const lit = Math.min(
    SEGMENTS,
    Math.ceil((sol / RECOMMENDED_SOL_BALANCE) * SEGMENTS)
  )

  return (
    <span
      className={styles.fuel}
      data-state={state}
      role='meter'
      aria-label='SOL for network fees'
      aria-valuemin={0}
      aria-valuemax={RECOMMENDED_SOL_BALANCE}
      aria-valuenow={Math.min(sol, RECOMMENDED_SOL_BALANCE)}
    >
      {Array.from({ length: SEGMENTS }, (_, index) => (
        <span
          key={index}
          className={styles.fuelSegment}
          data-on={index < lit}
        />
      ))}
    </span>
  )
}
